const options = [
  { key: '1', value: 'aspak', text: 'Aspak' },
  { key: '2', value: 'pak', text: 'Pak' },
  { key: '3', value: 'mesatarisht', text: 'Mesatarisht' },
  { key: '4', value: 'shumë', text: 'Shumë' }
]

const options2 = [
  { key: '1', value: 'jo_i_mirë', text: 'Jo i mirë' },
  { key: '2', value: 'relativisht_i_mirë', text: 'Relativisht i mirë' },
  { key: '3', value: 'i_shkëlqyer', text: 'I shkëlqyer' }
]

const options3 = [
  { key: '1', value: 'dobët', text: 'Dobët' },
  { key: '2', value: 'i_kënaqshëm', text: 'I kënaqshëm' },
  { key: '3', value: 'mesatar', text: 'Mesatar' },
  { key: '4', value: 'i_mirë', text: 'I mirë' },
  { key: '5', value: 'shumë_i_mirë', text: 'Shumë i mirë' }
]

const options4 = [
  { key: '1', value: 'aspak_mirë', text: 'Aspak mirë' },
  { key: '2', value: 'mesatarisht_mirë', text: 'Mesatarisht mirë' },
  { key: '3', value: 'shkëlqyeshëm', text: 'Shkëlqyeshëm' }
]

const options5 = [
  { key: '1', value: 'jo', text: 'Jo' },
  { key: '2', value: 'po', text: 'Po' }
]

const options6 = [
  { key: '1', value: '1', text: '1' },
  { key: '2', value: '2', text: '2' },
  { key: '3', value: '3', text: '3' },
  { key: '4', value: '4', text: '4' },
  { key: '5', value: '5', text: '5' }
]

const options7 = [
  { key: '1', value: 'paga_bonusi_benefitet', text: 'Paga / bonusi / benefitet' },
  { key: '2', value: 'teamleader', text: 'Teamleader' },
  { key: '3', value: 'orari', text: 'Orari' },
  { key: '4', value: 'ngarkesa_e_punës', text: 'Ngarkesa e punës' },
  { key: '5', value: 'roli_detyrat', text: 'Roli / detyrat' },
  { key: '6', value: 'zhvillimi_avancimi', text: 'Zhvillimi / avancimi' },
  { key: '7', value: 'organizimi_i_punës', text: 'Organizimi i punës' },
  { key: '8', value: 'kultura_e_punës', text: 'Kultura e punës' },
  { key: '9', value: 'menaxhmenti', text: 'Menaxhmenti' },
  { key: '10', value: 'oferte_më_e_mirë', text: 'Ofertë më e mirë' },
  { key: '11', value: 'tjeter', text: 'Tjetër' }
]

export const questions = [
  // Seksioni 1: Përvoja e Punës në SPEEEX
  {
    name: 'Si do ta vlerësonit përvojën tuaj të përgjithshme të punës në SPEEEX?',
    inputName: 'q0',
    type: 'radio',
    options: options3,
    required: true
    // section: 'Seksioni 1: Përvoja e Punës në SPEEEX'
  },
  {
    name: 'Sa të qarta kanë qenë detyrat, pritjet dhe objektivat e rolit tuaj?',
    inputName: 'q1',
    type: 'radio',
    options: options3,
    required: true
    // section: 'Seksioni 1: Përvoja e Punës në SPEEEX'
  },
  {
    name: 'Sa i/e kënaqur keni qenë me pagën, bonuset dhe benefitet në raport me punën tuaj?',
    inputName: 'q2',
    type: 'radio',
    options: options3,
    required: true
    // section: 'Seksioni 1: Përvoja e Punës në SPEEEX'
  },
  {
    name: 'Sa i/e kënaqur keni qenë me mundësitë për zhvillim, mësim dhe avancim brenda kompanisë?',
    inputName: 'q3',
    type: 'radio',
    options: options3,
    required: true
    // section: 'Seksioni 1: Përvoja e Punës në SPEEEX'
  },
  {
    name: 'Sa i/e kënaqur keni qenë me organizimin e punës dhe orarin tuaj?',
    inputName: 'q4',
    type: 'radio',
    options: options3,
    required: true
    // section: 'Seksioni 1: Përvoja e Punës në SPEEEX'
  },
  {
    name: 'A do ta rekomandonit SPEEEX si vend pune për dikë tjetër?',
    inputName: 'q5',
    type: 'radio',
    options: options5,
    required: true
    // section: 'Seksioni 1: Përvoja e Punës në SPEEEX'
  },
  // Seksioni 4: Arsyet e Largimit (pyetje me tekst + radio)
  {
    name: 'Kur keni filluar të mendoni për largim?',
    inputName: 'q6',
    type: 'text',
    required: true
    // section: 'Seksioni 4: Arsyet e Largimit'
  },
  {
    name: 'Çfarë ka ndikuar më së shumti që ta mendoni një ndryshim?',
    inputName: 'q7',
    type: 'text',
    required: true
    // section: 'Seksioni 4: Arsyet e Largimit'
  },
  {
    name: 'Cila ishte arsyeja kryesore për largimin tuaj (arsyeja më e rëndësishme që ka ndikuar në vendimin final)?',
    inputName: 'q8',
    type: 'radio',
    options: options7,
    useSelect: true,
    multiSelect: true,
    otherOptionValue: 'tjeter',
    required: true
    // section: 'Seksioni 4: Arsyet e Largimit'
  },
  {
    name: 'Çfarë do të duhej të kishte bërë ndryshe kompania që ju të kishit menduar të qëndronit më gjatë?',
    inputName: 'q9',
    type: 'text',
    required: true
    // section: 'Seksioni 4: Arsyet e Largimit'
  },
  {
    name: 'Çfarë e ka bërë mundësinë tuaj të re më tërheqëse për ju?',
    inputName: 'q10',
    type: 'text',
    required: true
    // section: 'Seksioni 4: Arsyet e Largimit'
  },
  {
    name: 'Çfarë duhet të përmirësojë kompania për të parandaluar largime të ngjashme në të ardhmen?',
    inputName: 'q11',
    type: 'text',
    required: true
    // section: 'Seksioni 5: Perspektiva për të Ardhmen'
  }
]
